import React from 'react';
import cn from 'classnames';
import styles from './FormationInformations.module.sass';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import Dropdown from '../../../components/Dropdown';
import MultiSelect from '../../../components/Multiselect';

const TYPE_DIPLOME_OPTIONS = [
    // Diplôme ou titre de niveau bac +5 et plus
    { value: '80', title: '80 : Doctorat' },
    { value: '73', title: '73 : Master' },
    { value: '75', title: '75 : Diplôme d\'ingénieur' },
    { value: '76', title: '76 : Diplôme d\'école de commerce' },
    { value: '79', title: '79 : Autre diplôme ou titre de niveau bac+5 ou plus' },
    // Diplôme ou titre de niveau bac +3 et 4
    { value: '62', title: '62 : Licence professionnelle' },
    { value: '63', title: '63 : Licence générale' },
    { value: '64', title: '64 : Bachelor universitaire de technologie BUT' },
    { value: '69', title: '69 : Autre diplôme ou titre de niveau bac +3 ou 4' },
    // Diplôme ou titre de niveau bac +2
    { value: '54', title: '54 : Brevet de Technicien Supérieur' },
    { value: '55', title: '55 : Diplôme Universitaire de technologie' },
    { value: '58', title: '58 : Autre diplôme ou titre de niveau bac+2' },
    // Diplôme ou titre de niveau bac
    { value: '41', title: '41 : Baccalauréat professionnel' },
    { value: '42', title: '42 : Baccalauréat général' },
    { value: '43', title: '43 : Baccalauréat technologique' },
    { value: '44', title: '44 : Diplôme de spécialisation professionnelle' },
    { value: '49', title: '49 : Autre diplôme ou titre de niveau bac' },
    // Diplôme ou titre de niveau CAP/BEP
    { value: '33', title: '33 : CAP' },
    { value: '34', title: '34 : BEP' },
    { value: '35', title: '35 : Certificat de spécialisation' },
    { value: '38', title: '38 : Autre diplôme ou titre de niveau CAP/BEP' },
    // Aucun diplôme ni titre
    { value: '25', title: '25 : Diplôme national du Brevet' },
    { value: '26', title: '26 : Certificat de formation générale' },
    { value: '13', title: '13 : Aucun diplôme ni titre professionnel' },
];

// Niveau de diplôme
const NIVEAU_DIPLOME_OPTIONS = [
    { value: 'master', title: '1ère année de Master' },
    { value: 'licence_pro', title: 'Licence professionnelle' },
    { value: 'licence_generale', title: 'Licence générale' },
    { value: 'but', title: 'Bachelor Universitaire de technologie BUT' },
    { value: 'autre_bac3', title: 'Autre diplôme ou titre de niveau bac +3 ou 4' }
];

// Degré de diplôme (utilise TYPE_DIPLOME_OPTIONS)
const DEGRE_DIPLOME_OPTIONS = TYPE_DIPLOME_OPTIONS;

// Type de formation
const TYPE_OF_FORMATION = [
    { value: 'Qualifiante', title: 'Qualifiante' },
    { value: 'RNCP', title: 'RNCP' },
];

// Type de contrat
const TYPE_OF_CONTRACT = [
    { value: 'Apprentissage', title: 'Apprentissage' },
    { value: 'Professionnalisation', title: 'Professionnalisation' },
    { value: 'Initial', title: 'Initial' },
];

const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
};

const FormationInformations = ({ formation, onFormationChange, onDropdownChange, loading }) => {
    return (
        <Card className={styles.card} title="Informations de la formation" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Intitulé exact du diplôme"
                    name="exact_title_of_qualification"
                    type="text"
                    placeholder="Intitulé précis du diplôme ou titre visé"
                    value={formation?.exact_title_of_qualification || ''}
                    onChange={onFormationChange}
                    required
                    maxLength={255}
                />
                <TextInput
                    className={styles.field}
                    label="Intitulé ou titre préparé"
                    name="prepared_title_or_qualification"
                    type="text"
                    placeholder="Intitulé précis du diplôme ou titre visé"
                    value={formation?.prepared_title_or_qualification || ''}
                    onChange={onFormationChange}
                    required
                    maxLength={255}
                />
                <TextInput
                    className={styles.field}
                    label="Code RNCP"
                    name="rncp_code"
                    type="text"
                    placeholder="Numéro RNCP du diplôme ou titre visé"
                    value={formation?.rncp_code || ''}
                    onChange={onFormationChange}
                    required
                    maxLength={9}
                />
                <TextInput
                    className={styles.field}
                    label="Code diplôme"
                    name="diploma_code"
                    type="text"
                    placeholder="Code du diplôme ou titre visé"
                    value={formation?.diploma_code || ''}
                    onChange={onFormationChange}
                    required
                    maxLength={8}
                />
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Degré du diplôme"
                        name="degre_diplome"
                        required
                        options={DEGRE_DIPLOME_OPTIONS}
                        setValue={(option) => onDropdownChange('degre_diplome', option.value)}
                        value={DEGRE_DIPLOME_OPTIONS.find(opt => opt.value === formation?.degre_diplome) || ''}
                    />
                </div>
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Niveau du diplôme"
                        name="niveau_diplome"
                        required
                        options={NIVEAU_DIPLOME_OPTIONS}
                        setValue={(option) => onDropdownChange('niveau_diplome', option.value)}
                        value={NIVEAU_DIPLOME_OPTIONS.find(opt => opt.value === formation?.niveau_diplome) || ''}
                    />
                </div>
                <TextInput
                    className={styles.field}
                    label="Coût de la formation (€ /an)"
                    name="cost_diplome"
                    type="number"
                    step="0.01"
                    placeholder="Montant en euros"
                    value={formation?.cost_diplome || ''}
                    onChange={onFormationChange}
                />
                <TextInput
                    className={styles.field}
                    label="Coût total de la formation (€)"
                    name="total_cost_diplome"
                    type="number"
                    step="0.01"
                    placeholder="Montant total en euros"
                    value={formation?.total_cost_diplome || ''}
                    onChange={onFormationChange}
                />
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Type de formation"
                        name="type_of_training"
                        required
                        options={TYPE_OF_FORMATION}
                        setValue={(option) => onDropdownChange('type_of_training', option.value)}
                        value={TYPE_OF_FORMATION.find(opt => opt.value === formation?.type_of_training) || ''}
                    />
                </div>
                <div className={styles.field}>
                    <MultiSelect
                        className={styles.dropdown}
                        label="Type de contrat"
                        name="type_of_contract"
                        options={TYPE_OF_CONTRACT}
                        setValue={(event) => {
                            // Le MultiSelect renvoie un événement avec target.name et target.value (tableau)
                            const { name, value } = event.target;
                            onFormationChange({
                                target: {
                                    name,
                                    value
                                }
                            });
                        }}
                        value={formation?.type_of_contract ? 
                            // Si type_of_contract existe, convertir en objets pour le MultiSelect
                            formation.type_of_contract.map(type => 
                                TYPE_OF_CONTRACT.find(opt => opt.value === type) || { value: type, title: type }
                            ) : 
                            []
                        }
                    />
                </div>
            </div>
            <div className={styles.divider}></div>
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Durée de formation (heures)"
                    name="course_duration"
                    type="number"
                    placeholder="Ex: 400"
                    value={formation?.course_duration || ''}
                    onChange={onFormationChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Durée en distanciel (heures)"
                    name="number_of_hoursinstudy"
                    type="number"
                    placeholder="Ex: 100"
                    value={formation?.number_of_hoursinstudy || ''}
                    onChange={onFormationChange}
                />
            </div>

           
        </Card>
    );
};

export default FormationInformations;